module.exports = __webpack_public_path__ + "static/media/spinner.ab38f275.svg";